import React from 'react';
import RoundCheckbox from './components/RoundCheckbox';
import RefundItemAccordion from './components/RefundItemAccordion';
import styles from "../../styles.module.scss";
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import { DISCRETIONARY_REFUND, WITHDRAWAL_REFUND, getSupportingDoc } from '../../utils';
import SubTypeRefundDetailsForm from './components/SubTypeRefundDetailsForm';
import DownloadSupportingDoc from './components/DownloadSupportingDoc';
import WithdrwalRefundCalculations from './components/withdrawalRefundCalculations';
import DLPWithdrwalRefundForm from './components/DLPWithdrawalRefund';

export const weekDispVal = weekNumber => {
    if(weekNumber === 0) return "Before Batch";
    return `Week ${weekNumber}`;
}

const WithdrawalRefundItem = ({
    payableRefundInfo,
    selectedRefundItems,
    refundItemCheckboxHandler,
    refundDetailsForm,
    handleRefundDetailsForm,
    isConcessionRefund,
    isFullRefund,
    refundReasons,
    viewOnly,
    isLoanCase,
    setLoading,
    forRefundEdit,
    setRefundDetailsForm,
    isDLPCase,
    studentDetails
}) => {
    
    const isDiscretionaryRefund = selectedRefundItems?.includes(DISCRETIONARY_REFUND);
    const isDisabled = (isConcessionRefund || isFullRefund || isDiscretionaryRefund);
    const withdrawalRefundPayableInfo  = payableRefundInfo?.[WITHDRAWAL_REFUND] ?? {};
    const { totalRefundableAmount , weekNumber} = withdrawalRefundPayableInfo;
    // const {daysUsed} = payableRefundInfo;

    const isSelected = selectedRefundItems?.includes(WITHDRAWAL_REFUND);
    const enableItemSelection = !viewOnly && !forRefundEdit;

    const {dlpWithdrawalRefundDetails = {}} = refundDetailsForm;

    const maxRefundAmount = isDLPCase
        ? (dlpWithdrawalRefundDetails?.netRefundableAmount ?? 0)
        : totalRefundableAmount
    
    const {payableToParent, payableToVendor} = refundDetailsForm?.[WITHDRAWAL_REFUND];
    const withdrawalRefundAmount = Number(payableToParent) + Number(payableToVendor);

    const disableFormFields = isDisabled || !isSelected || viewOnly;


    return (
        <RefundItemAccordion
            isDisabled={isDisabled}
        >
            <div className='d-flex align-items-center'>

                {
                    enableItemSelection &&
                    <RoundCheckbox
                        isChecked={isSelected}
                        onChange={(checked) => refundItemCheckboxHandler(WITHDRAWAL_REFUND, checked)}
                        isDisabled={isDisabled}
                    />
                }

                <div className={`${styles['accordion-title']} mr-1`}>Withdrawal •</div>

                <div className={`${styles['amount']}`}>{formattedPrice(isDLPCase ? withdrawalRefundAmount :totalRefundableAmount)}</div>
                <div className='d-flex ml-auto'>

                    <div className={styles['withdrawal-week-chip']}>{weekDispVal(weekNumber)}</div>
                    
                    <DownloadSupportingDoc
                        isDisabled={isDisabled}
                        isSelected={isSelected}
                        refundDetailsForm={refundDetailsForm}
                        refundSubType={WITHDRAWAL_REFUND}
                        isLoanCase={isLoanCase}
                        setLoading={setLoading}
                    />

                </div>
            </div>

            <div className='d-flex flex-column' style={{ gap: '1.5rem' }}>

                {isDLPCase
                    ? <DLPWithdrwalRefundForm
                        dlpWithdrawalRefundDetails={dlpWithdrawalRefundDetails}
                        setRefundDetailsForm={setRefundDetailsForm}
                        studentDetails={studentDetails}
                        disableFormFields={disableFormFields}
                        viewOnly={viewOnly}
                    />
                    : <WithdrwalRefundCalculations
                        withdrawalRefundPayableInfo={withdrawalRefundPayableInfo}
                        refundDetailsForm={refundDetailsForm}
                    />
                }


                <SubTypeRefundDetailsForm
                    refundItemName={WITHDRAWAL_REFUND}
                    form={refundDetailsForm}
                    formHandler={handleRefundDetailsForm}
                    amountFieldRequired
                    isDisabled={disableFormFields}
                    // reasonInputType='input'
                    reasonsDropdownData={refundReasons?.[WITHDRAWAL_REFUND]}
                    maxRefundAmount={maxRefundAmount}
                    isLoanCase={isLoanCase}
                    disableAmountFields={!isDLPCase}
                />
            </div>

        </RefundItemAccordion>

    );
}

export default WithdrawalRefundItem;